<div class="mt-8">

    <div *ngIf="channel" class="w-full flex flex-row justify-between mb-6">

        <button [routerLink]="['..']"
            class="text-primary-500 hover:bg-primary-100 text-sm uppercase font-bold px-4 py-2 rounded outline-none focus:outline-none ease-linear transition-all duration-150"
            type="button"><i class="fa fa-chevron-left mr-2 leading-relaxed"></i>
            Back
        </button>

        <div class="flex flex-row gap-4">
            <!-- <button (click)="deleteChannel()" [disabled]="working"
                class="bg-red-500 text-white active:bg-red-500 hover:bg-red-300 disabled:bg-primary-200 text-sm uppercase font-bold px-4 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
                type="button"><i class="fa fa-trash-can mr-2 leading-relaxed"></i>
                Delete
            </button> -->
            <button (click)="refreshChannel()" [disabled]="working"
                class="bg-primary-500 text-white active:bg-primary-700 hover:bg-primary-700 disabled:bg-primary-200 text-sm uppercase font-bold px-4 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
                type="button"><i class="fa fa-refresh mr-2 leading-relaxed"></i>
                Refresh
            </button>
        </div>

    </div>

    <div class="relative flex flex-col break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">

        <form [formGroup]="updateChannelForm" (ngSubmit)="updateChannel()">
            <div class="rounded-t bg-white mb-0 px-6 py-6">
                <div class="text-center flex justify-between items-center">
                    <span class="text-blueGray-700 text-lg font-bold">{{channel?.name}}</span>
                </div>
            </div>

            <div class="w-full px-4">
                <h6 class="text-blueGray-400 text-sm mt-6 mb-3 font-bold uppercase">
                    Channel Image
                </h6>
                <div class="flex flex-row w-full h-32">
                    <div *ngIf="channel?.imageUrl" class="rounded mr-4">
                        <img [src]="channel?.imageUrl" class="bg-white rounded h-32" />
                    </div>
                    <div>
                        <uppy-dashboard-modal [uppy]="uppy" [open]="showModal"
                            [props]="dashboardModalProps"></uppy-dashboard-modal>
                        <button type="button" (click)="showModal = !showModal"
                            class="rounded h-32 w-48 bg-primary-100 border-2 border-dashed border-primary-200">
                            <span class="text-sm text-primary-500">{{ showModal ? 'Close Upload Window' : "Upload New
                                Image" }}</span>
                            <span class="text-xs text-primary-300 inline-block">Only Images below 5 Mb</span>
                        </button>
                    </div>
                </div>

                <h6 class="text-blueGray-400 text-sm mt-6 mb-3 font-bold uppercase">
                    Channel Details
                </h6>
                <div class="flex flex-wrap">
                    <div class="w-full mb-4">
                        <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
                            Description
                        </label>
                        <textarea type="text" type="description" formControlName="description" id="description"
                            name="description" required
                            class="border-0 placeholder-blueGray-300 text-blueGray-600 bg-white whitespace-pre-line rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                            rows="4">{{channel?.description}}
                            </textarea>
                        <div
                            class="{{ description.invalid && (description.dirty || description.touched) ? 'visible': 'hidden'}} h-6 pt-1 text-red-500 text-sm">
                            <p *ngIf="description.errors?.['required']">
                                Value is required
                            </p>
                        </div>
                    </div>
                    <div class="w-full mb-4">
                        <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                            Tags
                        </label>
                        <div class="flex flex-wrap gap-1">
                            <button (click)="removeTag(i)" type="button" *ngFor="let item of tags; index as i"
                                data-dismissible="chip"
                                class="relative flex select-none items-center whitespace-nowrap rounded-lg bg-primary-500 py-1.5 px-3 text-xs font-bold text-white">
                                <span class="grow-0">{{item}}<i class="fa fa-close ml-2 leading-relaxed"></i></span>
                            </button>
                        </div>
                        <div class="flex flex-row align-middle mt-2">
                            <input formControlName="tags" id="tags" name="tags" type="text"
                                class="border-0 grow placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" />
                            <button (click)="addTag()" type="button"
                                class="bg-primary-500 basis-1/4 whitespace-nowrap rounded ml-4 text-xs text-white px-2">Add
                                Tag</button>
                        </div>
                        <div
                            class="{{tagField.invalid && (tagField.dirty || tagField.touched)? 'visible' : 'invisible' }} pt-1 h-4 text-red-500 text-xs">
                            @if(tagField.errors?.['required']) {
                            <p>Value is required</p>
                            } @else if(tagField.errors?.['invalidValue']) {
                            <p>No blanks or spaces allowed</p>
                            } @else if(tagField.errors?.['maxValuesAllowed']) {
                            <p>Only 10 values allowed</p>
                            }
                        </div>
                    </div>
                    <div class="mb-4">
                        <button type="submit" [disabled]="!updateChannelForm.valid || working"
                            class="bg-secondary-500 text-white active:bg-primary-500 hover:bg-secondary-700 hover:text-white text-sm uppercase font-bold px-4 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150">
                            <div *ngIf="!working" class="inline-block">
                                <i class="fa fa-save mr-2 leading-relaxed"></i>Update
                            </div>
                            <div *ngIf="working" class="inline-block">
                                <app-loading-dots></app-loading-dots>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>